<template>
  <default-layout>
    <div class="pa-4">
      <login formType="page" />
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Login from '@/components/auth/login';
import { mapState } from 'vuex';

import DefaultHeadMixin from '@/mixins/defaultHead';

export default {
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    Login,
  },
  computed: {
    ...mapState({}),
  },
  methods: {},
  mounted() {},
};
</script>
